import {
  AnalyticServiceContext,
  getAnalyticsValueForPackage,
} from '@grandstand-web/bally-web-shared/src/services/analytics/AnalyticService'
import { useTealium } from '@grandstand-web/bally-web-shared/src/services/tealium/TealiumService'
import { PackageDataResult } from '@grandstand-web/bally-web-shared/src/utils/presentationModels/PackageObjectV2'
import { useContext } from 'react'

interface SendPackageAnalyticsProps {
  packageData: PackageDataResult
  userIsPromoEligible?: boolean
  packagesZipcode: string
}

export const useSendSelectedPackageAnalytics = () => {
  const analyticService = useContext(AnalyticServiceContext)
  const tealium = useTealium()

  const sendPackageSelectionAnalytics = ({
    packageData,
    userIsPromoEligible,
    packagesZipcode,
  }: SendPackageAnalyticsProps) => {
    const { package: pkg, purchase_option, variant_type } = packageData
    const packageName = pkg.package_name.toLowerCase()

    tealium.selectPackage({
      package: packageName,
      package_duration: variant_type,
    })

    const isFreeTrial =
      userIsPromoEligible &&
      purchase_option.promotions?.find((promo) => promo.is_default_promotion && promo.is_free_trial)
        ? true
        : false
    const package_price = purchase_option.price
    const value = getAnalyticsValueForPackage(purchase_option, isFreeTrial)
    const dtc_product_ids = pkg.dtc_product_ids || []

    analyticService.selectPackageItem({
      package_zipcode: packagesZipcode,
      eligibility: 'eligible',
      package_rsn: dtc_product_ids.join('|'),
      subscription_type: isFreeTrial ? 'trial' : 'paid',
      message: '',
      package_price,
      value,
      ecommerce: {
        value,
        currency: 'USD',
        items: [
          {
            item_name: packageName,
            item_id: dtc_product_ids.join('|').toLowerCase().replace('_', ' '),
            item_brand: 'fanduel sports network',
            item_category: isFreeTrial ? 'trial' : 'paid',
            item_variant: variant_type,
            quantity: 1,
            price: purchase_option.price,
          },
        ],
      },
    })
  }

  return sendPackageSelectionAnalytics
}
